import React from "react";
import { TooltipCustom } from "../infra/styleGlobal";

// eslint-disable-next-line react/display-name
const View = ({ tooltip, style, onClick, children, load, loadSize, to, ...others }) => {
  return (
    <div
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      className={others.class}
      {...others}
      style={{ display: "flex", flexDirection: "column", ...style }}
    >
      {children}
    </div>
  );
};

export default View;
